import MappingTable from './MappingTable';

export default {
	MappingTable
};

export { MappingTable };
